import { ResponseDTOInterface } from '../../../Interface/Hook/Validator/ResponseDTOInterface';
import { filterResults } from '../Filter';
import { getValidatorResponse } from '../../../Service/ValidatorService';
import { ErrorResponse } from '../../../Interface/ErrorResponse';
import { StatusCodes } from 'http-status-codes';

const AMOUNT_RETRIES_ON_ERROR = 5;
const AMOUNT_RETRIES_ON_EMPTY_RESULT_SET = 10;
const MESSAGE_ON_EMPTY_RESULT = `Er konden geen resultaten gevonden worden na ${AMOUNT_RETRIES_ON_EMPTY_RESULT_SET} pogingen.`;
const MESSAGE_ON_ERROR = `De api heeft na ${AMOUNT_RETRIES_ON_ERROR} pogingen een foutmelding terug gegeven.`;

export const fetchResult = (id: string, amountRequests: number): Promise<ResponseDTOInterface> => {
    return new Promise<ResponseDTOInterface>((resolve, reject) => {
        amountRequests += 1;
        getValidatorResponse(id, amountRequests).then(
            response => {
                response = filterResults(response);
                if (response.results.length > 0) {
                    resolve({
                        amountRequests,
                        isLoading: false,
                        result: response.results[0],
                        label: response.results[0].label,
                        retry: false,
                    });
                } else {
                    resolve({
                        amountRequests,
                        error:
                            amountRequests === AMOUNT_RETRIES_ON_EMPTY_RESULT_SET
                                ? new Error(MESSAGE_ON_EMPTY_RESULT)
                                : undefined,
                        isLoading: true,
                        result: null,
                        retry: amountRequests < AMOUNT_RETRIES_ON_EMPTY_RESULT_SET,
                    });
                }
            },
            (errorResult: ErrorResponse) => {
                let errorMessage: string | undefined;
                let isError = true;
                let isLoading = true;
                let retry = amountRequests < AMOUNT_RETRIES_ON_ERROR;
                switch (errorResult.code) {
                    case StatusCodes.BAD_REQUEST:
                    case StatusCodes.PRECONDITION_REQUIRED:
                        isLoading = false;
                        retry = false;
                        break;
                    case StatusCodes.NOT_FOUND:
                    case StatusCodes.REQUEST_TIMEOUT:
                        isError = amountRequests === AMOUNT_RETRIES_ON_ERROR;
                        break;
                    case StatusCodes.SERVICE_UNAVAILABLE:
                        errorMessage = errorResult.message || MESSAGE_ON_ERROR;
                        isLoading = false;
                        retry = false;
                        break;
                }
                reject({
                    amountRequests,
                    error: isError ? new Error(errorMessage) : undefined,
                    errorCode: errorResult.code,
                    isLoading,
                    result: null,
                    retry,
                });
            },
        );
    });
};
